import React from "react";
import { useSelector } from "react-redux";

const TermsContents = () => {
	const { policyApiss } = useSelector((item) => item.policy);
	return (
		<div className="tc_content">
			<p
				className="blog-des"
				dangerouslySetInnerHTML={{
					__html: policyApiss == "" ? "" : policyApiss.data.data[1].content,
				}}
			/>
		</div>
	);
};

export default TermsContents;
